/* import axios from "axios";

// Define the base URL for the backend
const baseUrl = " https://eutracker.rdiup.com/v1/";

// Create an Axios instance
const AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 6000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Add a request interceptor to include the token
AxiosInstance.interceptors.request.use(
  (config) => {
    // Get the token from localStorage (or wherever it is stored)
    const token = localStorage.getItem("access_token"); // Ensure 'token' is the key where you store your JWT

    // If token exists, add it to the headers
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

export default AxiosInstance;
 */

import axios from "axios";

// Define the base URL for the backend
const baseUrl = " https://eutracker.rdiup.com/v1/";

// Create an Axios instance
const AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Set token refresh and inactivity timeout constants
const TOKEN_REFRESH_THRESHOLD = 10 * 60 * 1000; // 5 minutes before expiry
const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 2 hours

let inactivityTimeout;

function resetInactivityTimeout(logoutCallback) {
  // Clear previous timeout
  clearTimeout(inactivityTimeout);
  // Set a new inactivity timeout
  inactivityTimeout = setTimeout(() => {
    logoutCallback();
  }, INACTIVITY_TIMEOUT);
}

// Function to refresh the token
async function refreshToken() {
  try {
    const response = await axios.post(
      " https://eutracker.rdiup.com/api/token/refresh/",
      {
        refresh_token: localStorage.getItem("refresh_token"),
      }
    );
    const { access_token } = response.data;
    localStorage.setItem("access_token", access_token);
    return access_token;
  } catch (error) {
    console.error("Token refresh failed:", error);
    return null;
  }
}

// Request interceptor to include the token and refresh if close to expiry
AxiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("access_token");

    // Check if token needs refreshing based on expiration time
    if (token) {
      const tokenExp = JSON.parse(atob(token.split(".")[1])).exp * 1000; // Decode JWT expiration
      const now = Date.now();

      // If token is close to expiry, refresh it
      console.log("exprie", tokenExp - now, TOKEN_REFRESH_THRESHOLD);
      if (tokenExp - now < TOKEN_REFRESH_THRESHOLD) {
        console.log("i amexpering");

        const newToken = await refreshToken();
        if (newToken) {
          config.headers["Authorization"] = `Bearer ${newToken}`;
        } else {
          // If refresh failed, handle logout
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          window.location.href = "/login";
          return Promise.reject("Session expired, please log in again.");
        }
      } else {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Setup inactivity timeout on window activity events
window.addEventListener("mousemove", () => resetInactivityTimeout(logout));
window.addEventListener("keydown", () => resetInactivityTimeout(logout));
window.addEventListener("click", () => resetInactivityTimeout(logout));

// Define the logout function
function logout() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.clear();

  window.location.href = "/login";
}

// Export Axios instance
export default AxiosInstance;
